module.exports = __webpack_public_path__ + "img/mp.aa6f2a4.svg";